import { BoundForError } from '@/libs/BoundForError'

export class GameError extends BoundForError {}
